import api from './api.js';

class Customers {
    constructor(){
        this.url_customers = 'Customers'
    }
    get(data){
        return api.get(`${this.url_customers}/${data.id}`);
    }
    requestAccess(JdeNum){
      return api.post(`${this.url_customers}/requestAccess/${JdeNum}`)
    }
    jde(JdeNum){
      return api.get(`${this.url_customers}/JDE/${JdeNum}`)
    }
    filtered(data){
      return api.post(`${this.url_customers}/Search`, data);
    }
    all(){
      return api.get(`CurrentUser/${this.url_customers}/`);
    } 
    getDataSource(id){
      return api.getDataSource(`CurrentUser/${this.url_customers}`, id);
    }  
    uncommittedOrders(data){
      return api.get(`${this.url_customers}/${data.id}/UncommittedOrders`);
    }
    update(data){
      return api.put(`${this.url_customers}/${data.Id}`, data);
    }
    create(data){
        return api.post(`${this.url_customers}/`, data);
    }
}

export default new Customers;